import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 业务类型
 */
class BusinessType extends UltMeta {
    SHIPPING_ORDER_DEPOSIT = new Meta(1, "船运单定金");
}

export const BUSINESS_TYPE = new BusinessType();

/**
 *
 */
class TransferType extends UltMeta {
    WX = new Meta(1, "微信");
}

export const TRANSFER_TYPE = new TransferType();

class TransferState extends UltMeta {
    PROCESSING = new Meta(1, "转账中");
    FAIL = new Meta(2, "转账失败");
    SUCCESS = new Meta(3, "成功");
}

export const TRANSFER_STATE = new TransferState();
